import axios from "axios";
import store from "../store/Store";
import { message } from "antd";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

axiosInstance.interceptors.request.use((config) => {
  const stateData = store.getState();
  const User = stateData?.cauth?.user;
  console.log("User", User);
  if (User) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${User?.access_token}`,
    };
  }

  config.headers = {
    ...config.headers,
    Accept: "application/json",
  };

  return config;
});
export default axiosInstance;
// axiosInstance.interceptors.response.use(
//   (response) => {
//     return Promise.resolve(response);
//   },
//   (error) => {
//     console.log(error.code);
//     if (error?.response?.status === 401) {
//       localStorage.removeItem("persist:root");
//       window.location.reload();
//     }
//     if (error.code === "ERR_NETWORK") {
//       message.error("Request Timeout, Please try again later.");
//       window.location.reload();
//     }
//     return Promise.reject(error);
//   }
// );
